module.exports = __webpack_public_path__ + "static/teddy2-bcf5a1bfab4281f642d96ca907930b09.png";